import React from 'react';
import PropTypes from 'prop-types';
import SecondaryBanner from '@mshops-components-library/secondary-banner';

const { useRenderContext } = require('../../pages/home/context');

const BannerContainer = ({ link, ...restProps }) => {
  const { device, isEshops, shopType, features, appearance } = useRenderContext();
  const { tracking_id: trackingId = '' } = appearance?.appearance?.properties?.metrics || {};

  const encodedPlaceholder = '%7Btracking_id%7D';
  const encodedTrackingId = encodeURIComponent(trackingId);

  const updatedLink = trackingId
    ? { ...link, url: link.url.replace(encodedPlaceholder, encodedTrackingId) }
    : link;

  return (<SecondaryBanner
    {...restProps}
    link={updatedLink}
    deviceType={device}
    isEshops={isEshops}
    eshopType={shopType}
    hasNewStyles={features?.includes('styles_improvements')}
  />);
};

BannerContainer.propTypes = {
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    only_link: PropTypes.bool,
    rel: PropTypes.string,
    target: PropTypes.string,
    ccp_url_info: PropTypes.any,
    url_type: PropTypes.string,
  }).isRequired,
};

export default BannerContainer;
